import { Box, Grid, useTheme } from '@mui/material'
import { SectionHeader } from 'components/SectionHeader'
import { type LicensedEstablishmentDetailsProps } from '../types'
import {
  Facebook,
  Instagram,
  Google,
  Twitter,
  Web,
  Link,
} from '@mui/icons-material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faYelp } from '@fortawesome/free-brands-svg-icons'

export const LinksDetailsDesktop = ({
  licensedEstablishment,
}: LicensedEstablishmentDetailsProps) => {
  const theme = useTheme()

  return (
    <Box>
      <SectionHeader title="Links" showButton={false} />

      <Box
        border={{ md: `1px solid ${theme.palette.grey[200]}` }}
        borderRadius={'5px'}
        p={{ xs: 0, sm: 3 }}
      >
        <Grid container className="flex flex-row flex-wrap" spacing={2}>
          {licensedEstablishment?.links?.length !== 0 &&
            licensedEstablishment?.links?.map((link: any, i: number) => (
              <Grid item md={1} key={i++}>
                {link.name && link.url && (
                  <a
                    href={
                      link.url.startsWith('http')
                        ? link.url
                        : 'http://' + String(link.url)
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      color: 'inherit',
                    }}
                  >
                    {link.name === 'Facebook' && (
                      <Facebook sx={{ width: 24 }} />
                    )}
                    {link.name === 'Google' && <Google sx={{ width: 24 }} />}
                    {link.name === 'Twitter' && <Twitter sx={{ width: 24 }} />}
                    {link.name === 'Instagram' && (
                      <Instagram sx={{ width: 24 }} />
                    )}
                    {link.name === 'Yelp' && (
                      <FontAwesomeIcon icon={faYelp} size="lg" />
                    )}
                    {link.name === 'Location Website' && (
                      <Web sx={{ width: 24 }} />
                    )}
                    {link.name === 'Location Page Available' && (
                      <Link sx={{ width: 24 }} />
                    )}
                  </a>
                )}
              </Grid>
            ))}
        </Grid>
      </Box>
    </Box>
  )
}
